module.exports = __webpack_public_path__ + "img/detail-2.55a5c3a4.png";